import React, {FC} from 'react';

import {AppPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {AccountsInfoBannersContainer} from '../../banners/accounts/accountsInfoBannersContainer';
import {ApplicationBannersContainer} from '../../banners/applications/applicationBannersContainer';
import {ContactsManagerBannersContainer} from '../../banners/contactsManager/contactsManagerBannersContainer';
import {LensesBannersContainer} from '../../banners/lenses/lensesBannersContainer';
import {VoiceBannersContainer} from '../../banners/voice/voiceBannersContainer';
import {CalendarVersionImportBannerContainer} from '../../calendars/banners/calendarVersionImportBannerContainer';
import {LeftSandboxBannerContainer} from '../../onboarding/banners/leftSandboxBannerContainer';
import {AccountsCSVImportBannersContainer} from './accounts/accountsCSVImportBannersContainer';
import {AiKnowledgeSourceBanners} from './aiKnowledgeSource/aiKnowledgeSourceBanners';
import {AiTaggingBanners} from './aiTagging/aiTaggingBanners';
import {AnalyticsBannersContainer} from './analytics/analyticsBannersContainer';
import {BlockedBillingBannerContainer} from './billing/blockedBillingBannerContainer';
import {DiscountEndingBannerContainer} from './billing/discountEndingBannerContainer';
import {InvoicesPastDueBannerContainer} from './billing/invoicesPastDueBannerContainer';
import {RecentChargeFailedBannerContainer} from './billing/recentChargeFailedBannerContainer';
import {ContactsCsvExportBannersContainer} from './contacts/contactsCsvExportBanners/contactsCsvExportBannersContainer';
import {ContactsCsvImportBannersContainer} from './contacts/contactsCsvImportBannersContainer';
import {CriticalUpdateBannerContainer} from './criticalUpdate/criticalUpdateBannerContainer';
import {CrmSyncBannersContainer} from './crmSync/crmSyncBannersContainer';
import {DomainLoginBannerContainer} from './domainLogin/domainLoginBannerContainer';
import {ErrorBannersContainer} from './error/errorBannersContainer';
import {ImpersonationModeBannerContainer} from './impersonation/impersonationModeBannerContainer';
import {IntegrationEnabledBannersContainer} from './integration/integrationEnabledBannersContainer';
import {IntegrationErrorBannersContainer} from './integration/integrationErrorBannersContainer';
import {KnowledgeBaseBannersContainer} from './knowledgeBase/knowledgeBaseBannersContainer';
import {AbuserFlagBannerContainer} from './legal/abuserFlagBannerContainer';
import {MacrosBannerContainer} from './macros/macrosBannersContainer';
import {NewVersionBannerContainer} from './newVersion/newVersionBannerContainer';
import {OldDesktopVersionBanner} from './oldDesktopVersion/oldDesktopVersionBanner';
import {InviteTeammatesBannersContainer} from './teammates/inviteTeammatesBannersContainer';
import {TeamTrialEndedBannerContainer} from './teamTrialEnded/teamTrialEndedBannerContainer';
import {TrialEndedBannerContainer} from './trialEnded/trialEndedBannerContainer';
import {TrialRestartedBannerContainer} from './trialRestarted/trialRestartedBannerContainer';
import {UndoBannersContainer} from './undo/undoBannersContainer';

/*
 * Props.
 */

export interface AppBannersProps {
  panelId: AppPanelId;
}

/*
 * Component.
 */

export const AppBanners: FC<AppBannersProps> = ({panelId}) => (
  <>
    <ErrorBannersContainer panelId={panelId} />
    <UndoBannersContainer panelId={panelId} />

    <IntegrationErrorBannersContainer />
    <IntegrationEnabledBannersContainer />

    <NewVersionBannerContainer />
    <OldDesktopVersionBanner />
    <CriticalUpdateBannerContainer />

    <TrialRestartedBannerContainer />
    <TrialEndedBannerContainer panelId={panelId} />
    <DiscountEndingBannerContainer />
    <DomainLoginBannerContainer />
    <TeamTrialEndedBannerContainer />
    <InvoicesPastDueBannerContainer />
    <RecentChargeFailedBannerContainer />
    <BlockedBillingBannerContainer />
    <AbuserFlagBannerContainer />

    <ImpersonationModeBannerContainer />

    <CalendarVersionImportBannerContainer />

    <AccountsInfoBannersContainer panelId={panelId} />
    <ContactsManagerBannersContainer panelId={panelId} />

    <AccountsCSVImportBannersContainer panelId={panelId} />
    <ContactsCsvImportBannersContainer />
    <ContactsCsvExportBannersContainer />

    <CrmSyncBannersContainer panelId={panelId} />

    <ApplicationBannersContainer panelId={panelId} />

    <VoiceBannersContainer panelId={panelId} />

    <LensesBannersContainer panelId={panelId} />

    <AnalyticsBannersContainer panelId={panelId} />

    <KnowledgeBaseBannersContainer panelId={panelId} />

    <InviteTeammatesBannersContainer />

    <AiTaggingBanners />
    <AiKnowledgeSourceBanners />

    <MacrosBannerContainer panelId={panelId} />

    <LeftSandboxBannerContainer panelId={panelId} />
  </>
);
